import React, { useRef, useState } from 'react';
import './launch_product_videos.css';

const Launch_product_video = () => {
    const videoRef = useRef(null);
    const [hasPlayed, setHasPlayed] = useState(false);
    const [activeTab, setActiveTab] = useState(0);

    // Product data array
    const products = [
        {
            name: "Linkometic",
            // title: "Our Linkometic App",
            description: "LinkoMatic is a specialized tool designed to simplify and automate LinkedIn-based outreach and lead generation using AI. It's targeted at users wanting to generate premium high-ticket leads, with minimal manual work and no ad spend. Keep in mind limitations due to platform policies and evolving feature sets. Always review current pricing and terms before committing. If you'd like help comparing this to alternatives, reviewing user feedback or compliance with LinkedIn's ever‑changing API rules, feel free to ask!",
            link: "https://linkomatic.ai/",
            videoSrc: "img/linkomatic.mp4",
            posterSrc: "img/linkomatic (2).png"
        },
        {
            name: "ABITM",
            // title: "",
            description: "In essence, abitm.com is the online presence of ABITM Institute in Kolkata, offering professional training in digital marketing and software fields. It delivers modern, industry-relevant content, promotes strong placement support, and frequently features promotional offers to drive engagement and enrollment. Let me know if you'd like deep dives into specific course offerings, fee structure, placement partnerships, or comparisons with other training institutes!",
            link: "https://abitm.com/",
            videoSrc: "img/abitm.mp4",
            posterSrc: "img/abitm.png"
        },
        {
            name: "Browser Extension",
            // title: "Chrome Extension",
            description: "This Chrome Extension is a powerful AI-driven browser add-on developed using Python, Node.js, and React.js. It is designed to revolutionize the way users shop online by providing instant, contextual, and insightful product information right within their browser. By integrating seamlessly into e-commerce platforms like Amazon, this extension enriches the product browsing experience with intelligent summaries and data-driven recommendations.",
            link: "https://chrome.google.com",
            videoSrc: "img/extension.webm",
            posterSrc: "img/extension.png"
        },
        {
            name: "SEO management tool",
            // title: "Analytics Platform",
            description: "Linkomatic.ai is an AI-driven SEO management tool designed to automate internal linking across your website's content. By intelligently analyzing your blog posts, pages, and keywords, Linkomatic suggests and inserts relevant internal links—saving hours of manual effort and boosting your site's SEO performance.It's a must-have tool for content marketers, bloggers, SEO professionals, and agencies looking to scale content optimization with AI precision and speed.",
            link: "https://internal.linkomatic.ai/",
            // videoSrc: "img/analytics.mp4",
            posterSrc: "img/internal_linkomatic.png"
        }
    ];

    const handleVideoPlay = () => {
        if (videoRef.current) {
            videoRef.current.play();
            setHasPlayed(true);
        }
    };

    const handleTabChange = (index) => {
        if (videoRef.current) {
            videoRef.current.pause();
            videoRef.current.currentTime = 0;
            videoRef.current.load();
        }
        setActiveTab(index);
        setHasPlayed(false);
    };

    return (
        <div>
            <div className="container-xxl py-2">
                <div className="container px-lg-5">
                    <div className="position-relative text-center mb-3 pb-2 wow fadeInUp" data-wow-delay="0.1s">
                        <div className="services_heading mt-2">Recently Launched Our <span className='highlight'>Products</span></div>
                        <div className='services_subheading'>We deliver innovative, reliable software solutions tailored to your business. With expert teams, transparent pricing, and ongoing support.</div>
                        <span className="y-us-title-border"></span>
                    </div>
                </div>
            </div>

            {/* Tab Navigation */}
            <div className="container-xxl mb-4">
                <div className="row justify-content-center">
                    <div className="col-md-10">
                        <div className="product-tabs d-flex justify-content-center">
                            {products.map((product, index) => (
                                <button
                                    key={index}
                                    className={`tab-button ${activeTab === index ? 'active' : ''}`}
                                    onClick={() => {
                                        handleTabChange(index);
                                    }}
                                >
                                    {product.name}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* Product Content */}
            <div className="container-xxl py-2 px-0 wow zoomIn" data-wow-delay="0.1s">
                <div className="row g-0">
                    <div className="col-md-6 d-flex align-items-center">
                        <div className="p-2 mr-3">
                            <div className="services_heading text-uppercase mb-2">{products[activeTab].name}</div>
                            <div className="services_heading mb-2">{products[activeTab].title}</div>
                            <div className="services_subheading mb-4">
                                {products[activeTab].description}
                            </div>
                            <a href={products[activeTab].link} target="_blank" rel="noopener noreferrer" className="btn cta-button text-white py-md-3 px-md-5 me-3">Read More</a>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="video_it position-relative">
                            {products[activeTab].videoSrc ? (
                                <>
                                    {!hasPlayed && (
                                        <button type="button" className="btn-play" onClick={handleVideoPlay}>
                                            <span></span>
                                        </button>
                                    )}
                                    <div className="ratio ratio-16x9">
                                        <video 
                                            ref={videoRef} 
                                            controls 
                                            poster={products[activeTab].posterSrc}
                                            key={products[activeTab].videoSrc} // Add key prop
                                        >
                                            <source src={products[activeTab].videoSrc} type="video/mp4" />
                                            Your browser does not support the video tag.
                                        </video>
                                    </div>
                                </>
                            ) : (
                                <div className="ratio ratio-16x9">
                                    <img 
                                        src={products[activeTab].posterSrc} 
                                        alt={products[activeTab].name}
                                        style={{ objectFit: 'contain', width: '100%', height: '100%' }}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Launch_product_video;
